import type {State} from 'src/reducers';
import type {
  DashboardTaskCounts,
  DashboardTaskTab,
  TaskAndReminderState,
  TaskDetailsResponse,
  TaskTypeOption,
} from 'src/types/task-and-reminder';


export const selectTaskAndReminder = (state: State): TaskAndReminderState =>
  state.taskAndReminder;

export const selectIsTaskDetailsLoading = (state: State): boolean =>
  selectTaskAndReminder(state).isGettingTaskDetails;

export const selectTaskDetailsError = (state: State): unknown =>
  selectTaskAndReminder(state).getTaskDetailsError;

export const selectTaskDetails = (state: State) =>
  selectTaskAndReminder(state).taskDetails;

export const selectIsFetchingTasks = (state: State): boolean =>
  selectTaskAndReminder(state).isFetchingTasks;

export const selectIsFetchingMoreTasks = (state: State): boolean =>
  selectTaskAndReminder(state).isFetchingMoreTasks;

export const selectTaskList = (state: State): Array<TaskDetailsResponse> =>
  selectTaskAndReminder(state).taskList;

export const selectTaskListTotalRecords = (state: State): number =>
  selectTaskAndReminder(state).taskListTotalRecords;

export const selectTaskTypes = (state: State): Array<TaskTypeOption> =>
  selectTaskAndReminder(state).taskTypes;

export const selectDashboardTaskCounts = (state: State): DashboardTaskCounts =>
  selectTaskAndReminder(state).dashboardTaskCounts;
